import React from 'react';
import "./css/Footer.css";
import { Link } from 'react-router-dom';
import logo from "../assets/logo.png";
const Footer=()=>{
return(<>
<footer className='main-footer-div'>
<div className='footer-div1'>
    <div className='footer-div1-content'>
        <div className='header-content'>
            <div className='footer-linkheader'>
            <Link to='/'>Home</Link>
            <Link to='/about'>About</Link>
            <Link to='/contact'>Contact</Link>
            </div>
            <div className='footer-linkheader'>
                <Link to='/'>term and condition</Link>
                <p className='contact-us-slash'>/</p>
                <Link to='/'>Privacy Policy</Link>
                </div>
        </div>
        <div className='footer-div1-content2'>
            <h1 className='heading-large footer-heading'>Wood</h1>
            <div className='footer-div1-content2-content'>
                <p className='text-style-footer1'>Turn plans into reality</p>
                <p className='text-style-footer1'>Turn drawing into reality</p>
                <p className='text-style-footer1'>Turn dreams into reality</p>
            </div>
            <div className='footer-div1-content2-content2-circle'>
                <p className='text-style-footer2'>Get Architecture Consulting!</p>
            </div>
        </div>
        <div className='footer-div1-content3'>
            <div className='footer-div1-content3-content1'>
                <div className='footer-logo-div'>
                    <div className='logo-div'>
                                   <Link to='/'><img src={logo} alt="logo"/></Link>
                               </div>
                               <div className='mail-col-div'>
                                <p className='mail-text'>dhimanwoodwork@gmail.com</p>
                                <p className='mail-text2'>Precision Plan Architect</p>
                               </div>
                </div>
                <div className='footer-div1-content3-content2'>
                    <div>
                <p className='call-us'>Address:</p>
                    <p className='footer-head-style'>HPA-R3-SCO-023, DLF HYDE PARK ESTATE, New Chandigarh, Mullanpur, Punjab-140901</p>
                    </div>
                    <div className='footer-div1-content3-content2-content-newcontainer'>
                        <p className='call-us'>Mail us:</p>
                        <p className='footer-head-style'>dhimanwoodwork41@gmail.com</p>
                    </div>
                    <div className='footer-div1-content3-content2-content-newcontainer'>
                        <p className='call-us'>call us:</p>
                        <p className='footer-head-style'> +91 9814562530 , +91 7807462535,+91 82858 70007</p>
                    </div>
                </div>
            </div>
            <div className='footer-div1-content3-content2'>
                <h2 className='heading-small color-white '>OUR PROJECTS</h2>
                <div className='links-contain3'>
                    <Link to='/'>Residential</Link>
                    <Link to='/'>Commercial</Link>
                    <Link to='/'>Interior</Link>
                    <Link to='/'>Exterior</Link>
                </div>
            </div>
            <div className='footer-div1-content3-content3'>
                <h2 className='heading-small color-white '>Links</h2>
                <div className='links-contain3'>
                    <Link to='/'>Home</Link>
                    <Link to='/about'>About</Link>
                    <Link to='/services'>Our Services</Link>
                    <Link to='/gallery'>Gallery</Link>
                </div>
            </div>
        </div>
    </div>
</div>
<div className='footer-div2'>
    <p>Copyright © 2025 dhimanwoodwork. All Rights Reserved.</p>
</div>
</footer>
</>)
}
export default Footer;